module.exports = function() {
  return new Worker(__webpack_public_path__ + "02351a14b5156fd6aaed.worker.js");
};